/**
 * Error boundary for the Analytics module only.
 * Catches errors in Analytics routes so they cannot crash Admin Dashboard or Tax Review.
 * Renders a friendly fallback with Reload and Back links.
 */

import React from 'react';

class AnalyticsErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[AnalyticsErrorBoundary] Caught error:', error?.message ?? error, errorInfo?.componentStack ?? '');
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <h2 style={styles.title}>Analytics failed to load</h2>
          <p style={styles.message}>
            Something went wrong in the Analytics module. You can try reloading or return to Admin.
          </p>
          <div style={styles.actions}>
            <button type="button" onClick={() => window.location.reload()} style={styles.button}>
              Reload
            </button>
            <a href="/admin" style={styles.link}>Back to Admin</a>
            <a href="/modules/analytics" style={styles.link}>Back to Analytics</a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '32rem',
    margin: '2rem auto',
    fontFamily: 'system-ui, sans-serif',
  },
  title: { margin: '0 0 0.5rem', fontSize: '1.25rem' },
  message: { margin: '0 0 1rem', color: '#555' },
  actions: { display: 'flex', gap: '1rem', flexWrap: 'wrap' },
  button: {
    padding: '0.5rem 1rem',
    background: '#254860',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  link: { color: '#0f4c75', padding: '0.5rem 0' },
};

export default AnalyticsErrorBoundary;
